import React from 'react';
import PropTypes from 'prop-types';
import {Box, Text} from "rebass";


const recievedProps = {
	mr: 'auto'
};

const sentProps = {
	ml: 'auto',
	bg: 'purple',
	color: 'white'
};
const Message = ({message, profile}) => {
	return (
		<Box width={1} p={3}>
			{message.uid === profile.id ?
				<Box width={1 / 2} {...sentProps} p={2}>
					<Text>{message.message}</Text>
				</Box> :
				<Box width={1 / 2} {...recievedProps} p={2}>
					<Text>{message.message}</Text>
				</Box>
			}
		</Box>
	);
};

Message.propTypes = {
	message: PropTypes.object,
	profile: PropTypes.object
};

Message.defaultProps = {
	message: {id: 1, message: '', uid: '', seen: []},
	profile: {id: 1}
};

export default Message;
